import { AdditiveBlending, Color, Material, Mesh, MeshBasicMaterial, MeshPhysicalMaterial, MeshPhysicalMaterialParameters, MeshStandardMaterial, MultiplyBlending, NoBlending, NormalBlending, SubtractiveBlending } from "three"

export const materialToEnvironmentMap: { [key: string]: string } = {
  '#diamond': 'environmentDiamond.hdr',
  '#diamond.01': 'environmentDiamond.hdr',
  '#diamond.02': 'environmentDiamond.hdr',
  '#diamond.03': 'environmentDiamond.hdr',
  '#diamond.04': 'environmentDiamond.hdr',
  '#ed_moonstone': 'ED-Moonstone.hdr',
  '#ed_uniquestone': 'ED_UniqueStone.hdr',
  '#ed_alexandrite': 'ED_Alexandrite.hdr',
  '#pearl': 'environmentPeal.hdr',
  '#bulgary': 'environment9.hdr',
  '#natular-diamonds': 'environment2.hdr',
  '#diamond-isadora': 'environmentDiamondIsadora.hdr',
}

type FixedMeshPhysicalMaterialParameters = MeshPhysicalMaterialParameters & {thickness: number}

export function getOverloadedMaterial (mesh: Mesh, material: Material): Material | undefined {
  const name = material.name.toLowerCase()
  switch (name) {
    case '#refraction':
      return new MeshPhysicalMaterial({
        ...material,                
        thickness: 0.5      
      } as FixedMeshPhysicalMaterialParameters)
  }

  const meshName = mesh.name.toLowerCase()
  switch (meshName) {
    //if mesh name contains [band] or [base], we clone material to get rid of unexpected side effects
    case meshName.match(/band|base/)?.input: {
      return material.clone();
    }
    case '#shadow':
    case '#ground': {
      const mat = material as MeshStandardMaterial
      return new MeshBasicMaterial({
        alphaTest: material.alphaTest,
        blending: material.blending,
        color: mat.color,
        map: mat.map,
        alphaMap: mat.alphaMap,
        transparent: mat.transparent,
        opacity: mat.opacity,
        envMap : mat.envMap,
        blendDst: mat.blendDst,
        blendEquation: mat.blendEquation,
        blendSrc: mat.blendSrc,        
      })
    }
  }
}
